<div class="take-survey-wrapper w-full md:m-[0] sm:mt-[2rem]">
  <div
    *ngIf="loading; else page"
    class="loading flex justify-center items-center"
  >
    <mat-progress-spinner
      class="loading-spinner"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
  <ng-template #page>
    <div class="title-wrapper w-[95%] flex justify-center">
      <div class="title-section w-full">
        <div class="title-content">
          {{surveyDetails?.title}}
        </div>
        <div class="description-content">
          {{surveyDetails?.description}}
        </div>
      </div>
    </div>
    <div class="form-wrapper w-[95%] flex justify-center">
      <hr class="w-[95%] separator">
    </div>

    <div
      *ngIf="mode === 'view'"
      class="survey-form-wrapper w-[95%] flex items-center flex-col"
    >
      <div
        *ngFor="let questions of surveyDetails?.value[0]?.elements"
        class="w-[95%] survey-review-questions">
        <app-review-survey-questions
          [surveyQuestions]="questions"
        ></app-review-survey-questions>
      </div>
    </div>
    <div
      *ngIf="mode === 'view'"
      class="action-button-wrapper w-[95%] flex justify-center"
    >
      <hr class="w-[95%] separator">
    </div>
    <div
      *ngIf="mode === 'view'"
      class="action-wrapper w-[90%]  flex flex-col md:justify-start sm:flex-row"
    >
      <app-primary-button
        (handleClick)="backButtonClicked()"
        class="sm:w-[30%] md:w-[20%] w-full"
        type="small"
      >
        Back
      </app-primary-button>
      <app-primary-button
        (handleClick)="editButtonClicked()"
        class="sm:w-[30%] md:w-[20%]  w-full mt-[2rem] sm:mt-[0] sm:ml-[2rem]"
        type="small"
      >
        Edit
      </app-primary-button>
    </div>

    <div
      *ngIf="mode === 'edit'"
      class="survey-form-wrapper w-[98%] flex justify-center"
    >
      <div
        *ngIf="surveyDetails.value[0].elements.length>0"
        class="w-[95%]"
      >
        <survey [model]="surveyModel"></survey>
      </div>
    </div>
  </ng-template>

</div>
